import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import {Form, FormGroup, Label, Input } from 'reactstrap';
import {connect} from 'react-redux'
import AlertDanger from '../../components/AlertDanger'
import AlertSuccess from '../../components/AlertSuccess'
import SpinnerUp from '../../components/SpinnerUp'
import * as actions from '../../store/actions/users'

class UpdatePerfilPass extends Component{

    state = {
        password: "",
        error: "",
        success: "",
        loading: false,
    }

    onChangeInput = (ev) => {
        this.setState({[ev.target.name]: ev.target.value})
    }

    validate(){
        const {password} = this.state;
        if(!password){
            return this.setState({error: {message:  "Informe a senha!"}})
        }else if(password.length < 6){
            return this.setState({error: {message:  "A senha precisa ter no mínimo 6 caracteres!"}})
        }

        return true;
    }

    

    handleUpdate(){
        this.setState({success: ""});
        const {password} = this.state;
        if(!this.validate()) return
        
        this.setState({loading: true});

        this.props.handleUpdatePerfil({password}, (msg) => {
            if(msg.error.error){
                this.setState({error: {message: msg.error.message}})                
                this.setState({success: ""});
            }else{
                this.setState({error: ""});
                this.setState({success: {message: msg.error.message}});
            }
            
            this.setState({loading: false});
        });

    }

    render(){
        const {password, loading, error, success} = this.state
        return(
            <div className='p-4'>
                <div className="d-flex">
                <div className="mr-auto p-2">
                    <h2 className="titulo">Editar Senha</h2>
                </div>
                <Link to={"/perfil"}>
                    <button className="ml-1 btn btn-primary btn-sm">Perfil</button>
                </Link>
            </div>
            <hr />
            <AlertDanger error={error}/>
                <AlertSuccess error={success}/>
            <Form>
                    <FormGroup>
                        <Label for="password">Nova Senha</Label>
                        <Input type="password" value={password} name="password" id="password" placeholder="Digite a nova senha!" autoComplete="password" onChange={(ev) => this.onChangeInput(ev)}/>  
                    </FormGroup>
                    <Link onClick={() => this.handleUpdate()} to="#">
                        <SpinnerUp loading={loading}></SpinnerUp>
                    </Link>
                </Form>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    userDetails: state.user.userDetails
})

export default connect(mapStateToProps, actions)(UpdatePerfilPass);